import { H as S, Ze as c, u as N, b as d, Ye as T, p as x, bt as z } from "./abstract-base-CzLmw6_x-Ds3dPjNU.js";
import { e as E } from "./map-opRCbwgx-MWlUHMsM.js";
import { h as I, K as R, n as r, U as B } from "./overlay-primitive-CiEeU64K-CnoOxkmz.js";
import { L as h } from "./chart-tooltip-DohCEwmF-BAjjLWeZ.js";
import { t as C } from "./beacon-primitive-ChVMWFlW-Df2Js5lw.js";
import { o as u } from "./chart-tooltip.constants-GxIhQ8kK-Cbob2B6u.js";
import { r as v } from "./tooltip-arrows-yFbr-Skg-MMJdtHGb.js";
function $(b) {
  switch (b) {
    case r.BlockStart:
      return v.UP;
    case r.InlineEnd:
      return v.RIGHT;
    case r.InlineStart:
      return v.LEFT;
    case r.BlockEnd:
    default:
      return v.DOWN;
  }
}
const L = S`[beacon-tag-name=beacon-chart-tooltip][variant=single-line] [beacon-tag-name=beacon-chart-tooltip-data]{padding-inline:var(--beacon-unit-subatomic)}[beacon-tag-name=beacon-chart-tooltip][variant=multi-level] [beacon-tag-name=beacon-chart-tooltip-data]:not([subset]){--beacon-chart-tooltip-override-divider-border-block-end: var(--beacon-border-width-small) solid var(--beacon-chart-tooltip-divider-color-background);--beacon-chart-tooltip-override-container-main-padding-block-end: var(--beacon-unit-atomic)}[beacon-tag-name=beacon-chart-tooltip][variant=multi-level] [beacon-tag-name=beacon-chart-tooltip-data]:not([subset])+[beacon-tag-name=beacon-chart-tooltip-data][subset]{--beacon-chart-tooltip-override-container-subset-margin-block-start: var(--beacon-unit-atomic);margin-block-start:0}[beacon-tag-name=beacon-chart-tooltip][variant^=multi]>*:not(style)+*:not(style){margin-block-start:var(--beacon-unit-subatomic)}`, O = S`:host{inline-size:fit-content;inset-block-start:0;inset-inline-start:0;max-inline-size:var(--beacon-custom-chart-tooltip-size-max-inline-size, none)}:host(:not([is-open])){display:none}.tooltip-content{align-items:center;background-color:var(--beacon-chart-tooltip-color-background);border-radius:var(--beacon-unit-subatomic);box-shadow:var(--beacon-elevation-block-end-level-1);display:grid;min-block-size:var(--beacon-chart-tooltip-size-block-size);padding:var(--tooltip-padding)}.overlay-wrapper{inset-block-start:var(--top-offset);inset-inline-start:var(--left-offset);position:absolute}:host([variant=single-line]){--tooltip-padding: var(--beacon-chart-tooltip-space-padding-default)}:host([variant=single-line]) .overlay-wrapper{--arrow-margin: var(--beacon-unit-atomic);--arrow-block-size: calc(.375 * var(--beacon-unit-base));--arrow-inline-size: calc(.75 * var(--beacon-unit-base));display:flex;flex-direction:var(--flex-direction, column)}:host([variant=single-line]) .overlay-wrapper.block-end{--flex-direction: column-reverse}:host([variant=single-line]) .overlay-wrapper:is(.inline-end,.inline-start){--arrow-alignment-override: center;--arrow-block-size: calc(.75 * var(--beacon-unit-base));--arrow-inline-size: calc(.375 * var(--beacon-unit-base));--arrow-margin: 0}:host([variant=single-line]) .overlay-wrapper.inline-start{--flex-direction: row}:host([variant=single-line]) .overlay-wrapper.inline-end{--flex-direction: row-reverse}:host([variant=single-line]) .arrow-container{align-self:var(--arrow-alignment-override, var(--arrow-alignment, center));display:flex;inline-size:fit-content}:host([variant=single-line]) .arrow-container.start{--arrow-alignment: start;margin-inline-start:var(--arrow-margin)}:host([variant=single-line]) .arrow-container.center{margin:0}:host([variant=single-line]) .arrow-container.end{--arrow-alignment: end;margin-inline-end:var(--arrow-margin)}:host([variant=single-line]) .arrow-container .tooltip-arrow{block-size:var(--arrow-block-size);fill:var(--beacon-chart-tooltip-color-background);inline-size:var(--arrow-inline-size)}:host([variant^=multi-]){--beacon-chart-tooltip-override-label-padding-block-start: var(--beacon-unit-subatomic);--beacon-chart-tooltip-override-metric-padding-block-start: var(--beacon-unit-subatomic);--tooltip-padding: calc(var(--beacon-chart-tooltip-space-padding-list) + var(--beacon-chart-tooltip-space-padding-default))}.title{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-module-100) var(--beacon-font-family-default));margin-block-end:var(--beacon-unit-subatomic)}`;
var A = Object.defineProperty, n = (b, o, t, i) => {
  for (var e = void 0, a = b.length - 1, p; a >= 0; a--)
    (p = b[a]) && (e = p(o, t, e) || e);
  return e && A(o, t, e), e;
};
const f = class extends C(x, B()) {
  constructor() {
    super(...arguments), this.beaconTagName = u.beaconTagName, this.variant = h.SINGLE_LINE, this.tooltipTitle = "", this.disableTitle = !1, this.overrideColor = "", this.disableArrow = !1, this.tooltipData = [], this.trigger = I.MANUAL;
  }
  static get styles() {
    return [...super.styles, O];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, L];
  }
  /**
   * Determines what direction the tooltip should point
   */
  computeDirection() {
    this.variant === h.SINGLE_LINE && (this.direction = this.orientation === R.VERTICAL ? r.BlockEnd : r.InlineStart);
  }
  /**
   * Calculates the positioning of the tooltip
   */
  calculateOffset() {
    setTimeout(() => {
      let o, t;
      if (this.getBoundingClientRect() && (o = this.getBoundingClientRect()), this.getRootNode() && this.getRootNode().host && this.getRootNode().host.getBoundingClientRect() && (t = this.getRootNode().host.getBoundingClientRect()), this.targetRectObj) {
        const i = this.targetRectObj;
        if (this.computeDirection(), this.direction === r.BlockEnd) {
          const { x: e, y: a } = this.transformAnchorPoint(
            (i.left - o.left + (i.right - o.right)) / 2,
            i.top - t.top
          );
          this.leftOffset = e, this.topOffset = a - 4 + window.scrollY;
        } else if (this.direction === r.InlineStart) {
          const { x: e, y: a } = this.transformAnchorPoint(
            i.right - o.right,
            (i.top - t.top + (i.bottom - t.top)) / 2
          );
          this.leftOffset = e + 4, this.topOffset = a + window.scrollY;
        }
      }
    }, 0);
  }
  /**
   * Transforms the anchor point from the top left corner to the arrow point
   */
  transformAnchorPoint(o, t) {
    var i, e;
    let a = 0, p = 0;
    const w = (i = this.shadowRoot) == null ? void 0 : i.querySelector(".arrow-container"), y = (e = this.shadowRoot) == null ? void 0 : e.querySelector(this.overlaySelector);
    if (w && y) {
      const s = w.getBoundingClientRect(), k = y.getBoundingClientRect();
      let g = 0, m = 0;
      this.direction === r.BlockEnd ? (g = (s.left + s.right) / 2, m = s.bottom) : this.direction === r.InlineStart && (g = s.left, m = (s.top + s.bottom) / 2), a = g - k.x, p = m - k.y;
    }
    return { x: o - a, y: t - p };
  }
  /**
   * @returns template to render title
   */
  renderTitle() {
    return this.variant !== h.SINGLE_LINE && !this.disableTitle && this.tooltipTitle ? c`<div class="title">${this.tooltipTitle}</div>` : N;
  }
  /**
   * @returns template to render tooltip arrow
   */
  renderArrow() {
    return this.variant === h.SINGLE_LINE ? c`<div class="arrow-container ${this.alignment}">${this.disableArrow ? N : $(this.direction)}</div>` : c``;
  }
  /**
   * @returns template to render chart-tooltip-data
   */
  renderSlot() {
    var o;
    return (o = this.tooltipData) != null && o.length ? c`${E(
      this.tooltipData,
      (t) => z`<${this.getScopedTag("beacon-chart-tooltip-data")} label="${t.label}" value="${t.value}" index="${t.index}" color="${this.overrideColor}">
        </${this.getScopedTag("beacon-chart-tooltip-data")}>`
    )}` : c`<slot></slot>`;
  }
  /**
   * @returns template to override overlay content
   */
  renderOverlayContent() {
    return c`${this.renderTitle()}${this.renderSlot()}`;
  }
};
f.tagName = u.beaconTagName, f.nestedComponents = u.beaconNestedComponents;
let l = f;
n([
  d({ reflect: !0 })
], l.prototype, "variant");
n([
  d({ attribute: "tooltip-title" })
], l.prototype, "tooltipTitle");
n([
  d({ attribute: "disable-title", type: Boolean })
], l.prototype, "disableTitle");
n([
  d({ attribute: "override-color", type: String })
], l.prototype, "overrideColor");
n([
  d({ attribute: "disable-arrow", type: Boolean })
], l.prototype, "disableArrow");
n([
  d({ attribute: !1, type: Array })
], l.prototype, "tooltipData");
n([
  T()
], l.prototype, "trigger");
export {
  l as BeaconChartTooltip
};
